import axios from 'axios'
import { getToken, setToken } from '@/utils/auth'

const http = axios.create({
  baseURL: '/jianguanhui/api/v1',
  timeout: 20000
})

http.interceptors.request.use((config) => {
  const token = getToken()
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

http.interceptors.response.use(
  (res) => {
    const body = res.data || {}
    if (body.code === 40100) {
      setToken('')
      return Promise.reject(new Error(body.message || '请先登录'))
    }
    if (body.code !== 0) {
      return Promise.reject(new Error(body.message || '请求失败'))
    }
    return body.data
  },
  (err) => {
    const body = err && err.response && err.response.data
    const msg = (body && (body.message || body.msg)) || (err && err.message) || '请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default http
